export const useStoreSearch = defineStore('StoreSearch', {
    state: () => ({
        firstSearch: true,
        searchOpen: false,
        searchQuery: '',
    }),
    actions: {
        initSearch() {
            useStoreClasses().initClasses();
            useStoreEvents().initEvents();
            useStoreDancers().initDancers();
            useStoreVideos().initVideos();
        },
        async makeSearch(query) {
            if (this.firstSearch) {
                this.initSearch();
                this.firstSearch = false;
            }
            this.searchQuery = query;
        },
    },
    getters: {
        searchResults() {
            return () => {
                let result = [];
                if (!this.searchQuery) return result;
                const storeDancers = useStoreDancers();
                let dancers = storeDancers.searchDancers({dancerName: this.searchQuery});
                dancers.map((dancer) => {
                    result.push({
                        route: dancer.dancer_route,
                        heading: dancer.dancer_name,
                        excerpt:
                            'Dancer with ' +
                            dancer.dancer_videos +
                            ' Video' +
                            (parseInt(dancer.dancer_videos) === 1 ? '' : 's'),
                    });
                });
                const storeEvents = useStoreEvents();
                let events = storeEvents.searchEvents({eventTitle: this.searchQuery});
                events.map((event) => {
                    result.push({
                        route: event.event_route,
                        heading: event.event_title,
                        excerpt: 'Event in ' + event.event_state,
                    });
                });
                const storeClasses = useStoreClasses();
                let classes = storeClasses.searchClasses({searchText: this.searchQuery});
                classes.map((item) => {
                    result.push({
                        route: '/classes/' + item.slug,
                        heading: item.name,
                        excerpt: item.address ? 'Local classes - ' + item.address.split(', ').pop() : 'Local classes',
                    });
                });
                const storeVideos = useStoreVideos();
                let videos = storeVideos.searchVideos({videoTitle: this.searchQuery});
                videos.map((video) => {
                    result.push({
                        route: video.video_route,
                        heading: video.video_title,
                        excerpt: video.video_excerpt,
                    });
                });
                if (!result.length) {
                    result.push({
                        excerpt: '<p>No results found.</p>',
                    });
                }
                return result.slice(0, 10);
            };
        },
    },
});
